export default {
	types: {
		phone: "Phone",
	},
};
